import React from "react";

const InputComponent = ({
  name,
  type,
  placeholder,
  icon,
  onChange,
  onBlur,
  value,
  error,
}) => {
  return (
    <div className="relative">
      <div
        className={
          error
            ? "absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none text-red-500 text-[18px]"
            : "absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none text-[#6b7280] text-[18px]"
        }
      >
        {icon}
      </div>
      <input
        type={type}
        name={name}
        id={name}
        className={
          error
            ? "bg-red-50 border border-red-500 text-red-900 text-sm rounded-lg focus:none focus:none block w-full mt-2 ps-10 p-2.5"
            : "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mt-2 ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        }
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      />
    </div>
  );
};

export default InputComponent;
